import styled from 'styled-components';

import { scrollbar } from '@/theme/scrollbar';

export const ScrollableRow = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  margin-top: 20px;
  height: 420px;
  flex-wrap: nowrap;
  column-gap: 10px;
  ${scrollbar}

  & > :nth-child(1n) {
    flex-shrink: 0;
    width: 152px;
    height: 400px;
  }
  ${({ theme }) => theme.media.md.up} {
    display: flex;
    overflow-x: hidden;
    row-gap: 20px;
    column-gap: 2%;
    flex-wrap: wrap;
    height: auto;
    align-items: start;

    & > :nth-child(1n) {
      width: 18.33%;
      height: fit-content;
    }
  }
`;
